module.exports = __webpack_public_path__ + "img/down.9db1a434.svg";